export default {
  welcome: '歡迎'
}
